// Types
import type { SocialProfileNetworkType } from '@/types/socialProfileType';

// Routes
import { MANAGE_COMMENTS_TRACKER } from '@/lib/routes/privateRoutes';
import { LINKEDIN } from '@/lib/socialProfile';

import { GLOBAL_EVENT_TYPES } from '@/components/composite/Listeners/GlobalEventsListener';

export type NewFeatureReleasedType = {
    name: string;
    date: string;
    urls?: string[];
    globalEventQuery?: keyof typeof GLOBAL_EVENT_TYPES;
    socialNetworkType?: SocialProfileNetworkType[];
};

const NEW_FEATURES_RELEASED: NewFeatureReleasedType[] = [
    // INFO : To create a new notification for a feature just released add a new entry below using this pattern
    /*
    {
        name: 'new_feature_name', -> This will be used to store the notification "as read" in cookie
        date: '2022-06-07', -> The date of the release in YYYY-MM-DD format
        urls: [ANALYZE_OVERVIEW], -> The list of urls impacted by the new feature
        globalEventQuery: GLOBAL_EVENT_TYPES.TIKTOK_UPGRADE_API -> A global event query token
        socialNetworkType: [FACEBOOK] -> Optional : Don't use this property if the new feature is not restricted by social network type
    },
    */
    {
        name: 'linkedin_comments',
        date: '2024-04-10',
        urls: [MANAGE_COMMENTS_TRACKER],
        socialNetworkType: [LINKEDIN]
    }
];

export default NEW_FEATURES_RELEASED;
